module.exports = __webpack_public_path__ + "static/group-8-4fcc75c5e859cf3b4635e5b903e6788d.svg";